import React from 'react'
import styled from '@emotion/styled'
import { bool, func, string } from 'prop-types'

const ButtonWrap = styled.div`
	padding: 1rem;
`

const ButtonContainer = styled.div`
	text-align: center;
`

const Button = styled.button`
	${({ theme }) => theme.buttons.small};
	margin: auto;
`
LoadMoreButton.propTypes = {
	handleLoadMoreResults: func.isRequired,
	isLoadingMoreResults: bool.isRequired,
	text: string,
}

/**
 * This component is a button that calls the BE api to fetch more data
 * this should show up at the bottom of the search page results page
 * if there is more data to be shown
 *
 * onClick :: text changes to "Loading..." until loaded
 */
function LoadMoreButton({ handleLoadMoreResults, isLoadingMoreResults = false, text = 'More Content' }) {
	const handleClick = () => {
		handleLoadMoreResults()
	}

	return (
		<ButtonWrap>
			<ButtonContainer>
				<Button disabled={isLoadingMoreResults} onClick={handleClick} type="button">
					{isLoadingMoreResults ? 'Loading...' : text}
				</Button>
			</ButtonContainer>
		</ButtonWrap>
	)
}

export default LoadMoreButton
